export default __webpack_public_path__ + "static/media/image_scientist_large_desktop.697613cd.png";